import { brokerMobileOutFields } from '../_util/index';
export const DATA_TYPE_MAP = {
    year: 'year',
    sqft: 'sqft',
    money: 'money',
    float: 'float',
    days: 'days',
    date: 'date',
    none: 'none'
};
export const mobileOutFields = [
    'minPrice-maxPrice',
    'More-Than-Beds',
    'More-Than-Baths'
];
export { brokerMobileOutFields };
export const searchModuleType = {
    bigMap: 'big-map',
    gridList: 'grid-list'
};
